import Modal from './components/core/Modal/Modal'
import Toaster from './components/core/Toaster/Toaster'
import Login from './components/domain/Login/Login'
import Navbar from './components/domain/Navbar/Navbar'
import { handleWebSocketMessage } from './utilities/websocket'
import { useEffect } from 'react'
import { useData } from './contexts/Data'
import { useReady } from './contexts/Ready'
import { useCharacters } from './contexts/Characters'
import { usePersistentWebSocket } from './hooks/PersistentWebSocketHook'
import { useNavigate, useSearchParams } from 'react-router'

const AppLayout = ({ children }) => {
    const { sendMessage, lastMessage, readyState } = usePersistentWebSocket()
    const data = useData()
    const ready = useReady()
    const characters = useCharacters()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const discordCode = searchParams.get('code')

    useEffect(() => {
        if (lastMessage) handleWebSocketMessage(JSON.parse(lastMessage.data), {
            contexts: { data, characters }
        })
    }, [lastMessage])

    useEffect(() => {
        if (localStorage.jwt && window.location.pathname === '/login') navigate ('/')
        else if (!localStorage.jwt && !discordCode) navigate('/login')
        data.save('jwt', localStorage.jwt)
        setTimeout(() => ready.set('app'), 10)
    }, [])

    return (
            <>
                {ready.$state.app && (
                    <>
                        {data.$state.jwt && <Navbar />}
                        <main>{children}</main>
            
                        <Modal />
                        <Toaster />
                    </>
                )}
            </>
    )
}

export default AppLayout